import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Modal from "@mui/material/Modal";

import { ACTIONS as CHAT_ACTIONS } from "../../redux/chat";
import LinkArrow from "../link-arrow";
import UserPicture from "../user-picture";
import DropdownMemu from "../dropdown-menu";
import DeleteModal from "./delete-modal";

import StyledChatHeader from "./styles";

const ChatHeader = () => {
  const dispatch = useDispatch();
  const { info, firstMessage } = useSelector((state) => state.chat.currentChat);
  const [deleteModal, setDeleteModal] = useState(false);

  const goToProfileHandler = () => {
    dispatch(CHAT_ACTIONS.goToProfile());
  };

  const openDeleteModal = () => {
    setDeleteModal(true);
  };

  const onItemClickHandler = (id) => {
    switch (id) {
      case "delete":
        openDeleteModal();
        break;

      default:
        break;
    }
  };

  const onCloseModalHandler = () => {
    setDeleteModal(false);
  };

  return (
    <StyledChatHeader>
      <div className="chat-header-component">
        <div className="chat-header-left">
          <div className="back-arrow">
            <LinkArrow link="/chat" />
          </div>
          <div
            className="chat-header-component-info"
            onClick={goToProfileHandler}
          >
            <UserPicture
              name={info.name || undefined}
              surname={info.surname || undefined}
              image={info.profilePicture}
              size={50}
              loading={!info.name}
            />

            {info.name && (
              <div>
                <Typography
                  variant="subtitle1"
                  fontWeight={500}
                >{`${info.name} ${info.surname}`}</Typography>
              </div>
            )}
          </div>
        </div>
        <div className="chat-header-right">
          {firstMessage?.content && (
            <DropdownMemu
              onItemClick={onItemClickHandler}
              items={[
                {
                  id: "delete",
                  title: "Eliminar chat",
                  icon: <DeleteIcon />,
                  color: "#CE345A",
                },
              ]}
            />
          )}
        </div>
      </div>
      <Modal open={deleteModal}>
        <DeleteModal onClose={onCloseModalHandler} />
      </Modal>
    </StyledChatHeader>
  );
};

export default ChatHeader;
